import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BrandService } from '../../_services/brand.service';
import { Brand } from '../../_models/brand';

@Component({
  selector: 'app-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.css']
})
export class BrandListComponent implements OnInit {
  brands: Brand[];
  searchForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';
  page = 1;
  totalResults = 0;
  resultsPerPage = 0;

  constructor(private formBuilder: FormBuilder, private brandService: BrandService) { }

  ngOnInit() {
    this.searchForm = this.formBuilder.group({ argument: [''] });

    this.getBrands(this.page, this.searchForm.controls.argument.value);
  }

  onSubmit() {
    if (this.searchForm.invalid) {
      return;
    }

    this.page = 1;
    this.getBrands(this.page, this.searchForm.controls.argument.value);
  }

  onSelectedPage() {
    this.getBrands(this.page, this.searchForm.controls.argument.value);
  }

  private getBrands(page: number, argument: string) {
    this.submitted = true;

    this.loading = true;
    this.brandService.getBrands(page, argument)
      .subscribe(
        data => {
          this.page = data.pageNumber;
          this.resultsPerPage = data.resultsPerPage;
          this.totalResults = data.totalResults;
          this.brands = data.response;
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }
}
